import CoreInstance from '../CoreInstance';
import ClientInstance from 'api/ClientInstance';
import { localeFlag } from '../ApiHelpers';

const organizations = {
  // ..
};

const centers = {
  getCenter: () => CoreInstance.get('/centers/center'),
  getProgramActivityDetail: (groupId, programId, activityId) => CoreInstance.get(`/centers/groups/${groupId}/skill_programmes/${programId}/skill_programme_activities/${activityId}?${localeFlag()}`),
  getProgramCompletedInformation: (groupId, programId, activityId) => CoreInstance.get(`/centers/groups/${groupId}/skill_programmes/${programId}/skill_programme_activities/${activityId}/completed_information?${localeFlag()}`),
  getGroupDetail: (groupId) => CoreInstance.get(`/centers/groups/${groupId}`),
  postTeacher: (body) => ClientInstance.post('/centers/shared/teachers', body),
  putTeacher: (body, teacherId) => ClientInstance.put(`/centers/shared/teachers/${teacherId}`, body),
  deleteTeacher: (teacherId) => ClientInstance.delete(`/centers/shared/teachers/${teacherId}`),
};

export default {
  organizations,
  centers,
};
